import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../../Layout/Topo';
import Overlay from '../../Miscelania/Overlay';
import getLocale from '../../../i18n/getLocale';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class FlightReportLegFees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      regular_data: [],
      summarized_data: [],
      flight_report_id: '',
      flight_report_leg_id: '',
      location_id: '',
      exemption: '',
      provider_type: '',
      provider_id: '',
      fee_type: '',
      status_search: '',
      date_start: '',
      date_finish: '',
      aircraft_id: '',
      locations_select: [],
      aircrafts_select: [],
      airspace_responsibles_select: [],
      airport_operators_select: [],
      search_type: 'regular',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.showModal = this.showModal.bind(this);
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            locations_select: responseJson.data.locations_select,
            aircrafts_select: responseJson.data.aircrafts_select,
            airspace_responsibles_select: responseJson.data.airspace_responsibles_select,
            airport_operators_select: responseJson.data.airport_operators_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  search(event) {
    if (event !== null) {
      event.preventDefault();
    }
    this.handleAlert('', '', 'open');
    var datasave = {
      flight_report_id: this.state.flight_report_id,
      flight_report_leg_id: this.state.flight_report_leg_id,
      location_id: this.state.location_id,
      exemption: this.state.exemption,
      provider_type: this.state.provider_type,
      provider_id: this.state.provider_id,
      fee_type: this.state.fee_type,
      status: this.state.status_search,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      aircraft_id: this.state.aircraft_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voos/tarifas/pesquisar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            data: responseJson.data,
            regular_data: responseJson.data.regular,
            summarized_data: responseJson.data.summarized,
            searched: 1
          });
        }
        if (event !== null) {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button onClick={this.showModal.bind(this, row)} className="btn btn-primary btn-sm"><i className="fa fa-pencil"></i></button>
      </div>
    );

    return botao;
  }

  showModal(data, event) {
    this.setState({ id: data.id, status: data.status, modal: true });
  }

  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      status: this.state.status,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voos/tarifa/status', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            status: responseJson.data.status,
          });
          self.search(null);
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    var columns = null

    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeVoo.ControleGeralTarifa.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.DataInicial}:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="dd/mm/aaaa" required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.DataFinal}:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="dd/mm/aaaa" required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.TipoDePesquisa}:</label>
            <Select
              className=""
              name="search_type"
              value={this.state.search_type}
              searchable={true}
              placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
              onChange={this.handleSelectChange.bind(this, 'search_type')}
              options={[
                {label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTipoDePesquisa.PorTarifa, value: "regular"},
                {label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTipoDePesquisa.PorRelatorio, value: "summarized"},
              ]}
              required
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.Aeronave}:</label>
            <Select
              className=""
              name="aircraft_id"
              value={this.state.aircraft_id}
              searchable={true}
              placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
              onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
              options={this.state.aircrafts_select}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.Relatorio}:</label>
            <input type="text" className="form-control" name="flight_report_id" value={this.state.flight_report_id} placeholder={'Informe o número'} onChange={this.handleChange.bind(this, 'flight_report_id')} />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.Localidade}:</label>
            <Select
              className=""
              name="location_id"
              value={this.state.location_id}
              searchable={true}
              placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
              onChange={this.handleSelectChange.bind(this, 'location_id')}
              options={this.state.locations_select}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.Isencao}:</label>
            <Select
              className=""
              name="exemption"
              value={this.state.exemption}
              searchable={true}
              placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
              onChange={this.handleSelectChange.bind(this, 'exemption')}
              options={[
                {value: 0, label: this.locale.general.nao},
                {value: 1, label: this.locale.general.sim},
              ]}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.TipoDeFornecedor}:</label>
            <Select
            className="form-field-name"
            name="provider_type"
            value={this.state.provider_type}
            searchable={true}
            placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
            onChange={this.handleSelectChange.bind(this, 'provider_type')}
            options={[
              {value: "airspace_responsible", label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTipoDeFornecedor.ResponsavelPeloEspacoAereo},
              {value: "airport_operator", label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTipoDeFornecedor.OperadorDeAeroporto},
            ]}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.Fornecedor}:</label>
            {(this.state.provider_type === 'airspace_responsible') ?
                <Select
                className="form-field-name"
                name="provider_id"
                value={this.state.provider_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
                onChange={this.handleSelectChange.bind(this, 'provider_id')}
                options={this.state.airspace_responsibles_select}
                />
            :
                <Select
                className="form-field-name"
                name="provider_id"
                value={this.state.provider_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
                onChange={this.handleSelectChange.bind(this, 'provider_id')}
                options={this.state.airport_operators_select}
                />
            }
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.Tarifa}:</label>
            {(this.state.provider_type === 'airspace_responsible') ?
                <Select
                className="form-field-name"
                name="fee_type"
                value={this.state.fee_type}
                searchable={true}
                placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
                onChange={this.handleSelectChange.bind(this, 'fee_type')}
                options={[
                    {value: "route_navigation", label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTarifa.TarifaPan},
                    {value: "airport_control", label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTarifa.TarifaAdr},
                    {value: "approach_control", label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTarifa.TarifaApp},
                ]}
                />
            :
                <Select
                className="form-field-name"
                name="fee_type"
                value={this.state.fee_type}
                searchable={true}
                placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
                onChange={this.handleSelectChange.bind(this, 'fee_type')}
                options={[
                    {value: "landing", label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTarifa.TarifaTpo},
                    {value: "maneuvering_area", label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTarifa.TarifaPpm},
                    {value: "aircraft_stand", label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesTarifa.TarifaPpe},
                ]}
                />
            }
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.Status}:</label>
            <Select
              className=""
              name="status_search"
              value={this.state.status_search}
              searchable={true}
              placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.placeholder.Selecione}
              onChange={this.handleSelectChange.bind(this, 'status_search')}
              options={[
                {value: 'provisioned', label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesStatus.Provisionado},
                {value: 'billed', label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.OpcoesStatus.Faturado},
              ]}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.RelatoriosDeVoo.ControleGeralTarifa.formulario.botaoPesquisar}</button>
      </form>
      {self.state.searched === 1 &&
          <div>
            <hr/>
            {(this.state.search_type === 'regular') ?
              <BootstrapTable data={this.state.regular_data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
                <TableHeaderColumn dataField={'id'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>#</TableHeaderColumn>
                <TableHeaderColumn dataField={'date'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Data}</TableHeaderColumn>
                <TableHeaderColumn dataField={'flight_report_id'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.NumeroRelatorio}</TableHeaderColumn>
                <TableHeaderColumn dataField={'leg_number'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Trecho}</TableHeaderColumn>
                <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Aeronave}</TableHeaderColumn>
                <TableHeaderColumn dataField={'location_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Localidade}</TableHeaderColumn>
                <TableHeaderColumn dataField={'exemption_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Isento}?</TableHeaderColumn>
                <TableHeaderColumn dataField={'exemption_email_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='200'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.EmailDeIsencao}</TableHeaderColumn>
                <TableHeaderColumn dataField={'provider_type_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='250'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.TipoDeFornecedor}</TableHeaderColumn>
                <TableHeaderColumn dataField={'provider_id_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Fornecedor}</TableHeaderColumn>
                <TableHeaderColumn dataField={'fee_type_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='700'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Tarifa}</TableHeaderColumn>
                <TableHeaderColumn dataField={'currency_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Moeda}</TableHeaderColumn>
                <TableHeaderColumn dataField={'value_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Valor}</TableHeaderColumn>
                <TableHeaderColumn dataField={'status_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Status}</TableHeaderColumn>
                <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Acoes}</TableHeaderColumn>
              </BootstrapTable>
            :
              <BootstrapTable data={this.state.summarized_data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
                <TableHeaderColumn dataField={'flight_report_id'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.NumeroRelatorio}</TableHeaderColumn>
                <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Aeronave}</TableHeaderColumn>
                <TableHeaderColumn dataField={'date'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='100'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Data}</TableHeaderColumn>
                <TableHeaderColumn dataField={'leg_engine_start'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Partida}</TableHeaderColumn>
                <TableHeaderColumn dataField={'location_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Origem}</TableHeaderColumn>
                <TableHeaderColumn dataField={'location_class'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Classe}</TableHeaderColumn>
                <TableHeaderColumn dataField={'location_group'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Grupo}</TableHeaderColumn>
                <TableHeaderColumn dataField={'exemption'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Isento}?</TableHeaderColumn>
                <TableHeaderColumn dataField={'maneuvering_area_total_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.PatioManobra}</TableHeaderColumn>
                <TableHeaderColumn dataField={'aircraft_stand_total_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.AreaEstadia}</TableHeaderColumn>
                <TableHeaderColumn dataField={'total_landings'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Pousos}</TableHeaderColumn>
                <TableHeaderColumn dataField={'billable_ground_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.TempoDecorrido} - 03:00h</TableHeaderColumn>
                <TableHeaderColumn dataField={'landing'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Tpo}</TableHeaderColumn>
                <TableHeaderColumn dataField={'sum_stand_maneuvering'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Ppe}</TableHeaderColumn>
                <TableHeaderColumn dataField={'route_navigation'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Pan}</TableHeaderColumn>
                <TableHeaderColumn dataField={'approach_control'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.App}</TableHeaderColumn>
                <TableHeaderColumn dataField={'airport_control'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Adr}</TableHeaderColumn>
                <TableHeaderColumn dataField={'sum_fees_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='150'>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.tabela.Total}</TableHeaderColumn>
              </BootstrapTable>
            }

            {/* Modal de edição */}
            <Modal show={this.state.modal} aria-labelledby="contained-modal-title">
              <Modal.Header>
                <h4 className="pull-left">{this.locale.RelatoriosDeVoo.ControleGeralTarifa.modalEditarTarifa.titulo}</h4>
                <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
                <i className="fa fa-fw fa-close"></i></button>
                <div className="clearfix"></div>
              </Modal.Header>
              <Modal.Body>
                <form onSubmit={this.edit}>
                  <input type="hidden" name="id" className="form-control" value={this.state.id} />
                  <div className="form-group">
                    <label>{this.locale.RelatoriosDeVoo.ControleGeralTarifa.modalEditarTarifa.formulario.Status}:</label>
                    <Select
                      className=""
                      name="status"
                      value={this.state.status}
                      searchable={true}
                      placeholder={this.locale.RelatoriosDeVoo.ControleGeralTarifa.modalEditarTarifa.formulario.placeholder.Selecione}
                      onChange={this.handleSelectChange.bind(this, 'status')}
                      options={[
                        {value: 'provisioned', label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.modalEditarTarifa.formulario.OpcoesStatus.Provisionado},
                        {value: 'billed', label: this.locale.RelatoriosDeVoo.ControleGeralTarifa.modalEditarTarifa.formulario.OpcoesStatus.Faturado},
                      ]}
                    />
                  </div>     
                  <div className="form-group">
                    <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeVoo.ControleGeralTarifa.modalEditarTarifa.formulario.botaoEditar}</button>
                  </div>
                </form>
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
                <i className="fa fa-fw fa-close"></i></button>
              </Modal.Footer>
            </Modal>

          </div>
      }
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportLegFees;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Control/FlightReportLegFees.js